import axios from "axios";

export const API_BASE_URL = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

// Origem do backend: tira o /api do final se existir
export const API_ORIGIN = API_BASE_URL
  ? API_BASE_URL.replace(/\/api\/?$/, "")
  : "";

// Se quiser fallback seguro quando esquecer env (opcional):
const baseURL = API_BASE_URL || "/api";

export const TOKEN_STORAGE_KEY = "taxlien_token";

export function getStoredToken() {
  try {
    return localStorage.getItem(TOKEN_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setStoredToken(token) {
  try {
    if (!token) localStorage.removeItem(TOKEN_STORAGE_KEY);
    else localStorage.setItem(TOKEN_STORAGE_KEY, token);
  } catch {}
}

export const http = axios.create({
  baseURL,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

http.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

http.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status || 0;
    const data = err?.response?.data;
    const message =
      data?.error ||
      err?.message ||
      "Erro inesperado ao comunicar com o servidor";

    const normalized = new Error(message);
    normalized.status = status;
    normalized.data = data;
    return Promise.reject(normalized);
  }
);
